import update from 'immutability-helper'
import {
  LOAD_USERS,
  LOAD_USER_ROLES,
  CLEAR_USERS,
  GET_USER,
  DELETE_USER,
  NEW_USER,
  CLEAR_USER,
  STORE_USERS_SEARCHINFO,
  STORE_USERS_ACTIVEINFO,
  STORE_USERS_LASTSORT,
  CLEAR_USER_SEARCH_INFO,
  UPDATE_USER,
} from '../actions/action-types'

const initialState = {
  byId: [],
  byHash: {},
  usersLoaded: false,
  currentUser: null,
  validRoles: [],
  validAuthorities: [],
  searchInfo: { search: '' },
  activeInfo: { active: true },
  lastSort: {
    headerName: '',
    direction: '',
  },
  pagination: {
    pageNumber: 0,
    size: 0,
    totalElements: 0,
    totalPages: 0,
  },
}

// eslint-disable-next-line default-param-last
const users = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_USERS: {
      const userList = action.response
      const byId = []
      const byHash = {}

      userList.users.map(user => {
        byId.push(user.id)
        byHash[user.id] = user
        return byHash
      })

      return update(state, {
        usersLoaded: { $set: true },
        byId: { $set: byId },
        byHash: { $set: byHash },
        pagination: { $set: userList.pagination },
      })
    }
    case STORE_USERS_LASTSORT: {
      return update(state, {
        lastSort: { $set: action.lastSort },
      })
    }
    case STORE_USERS_SEARCHINFO: {
      return update(state, {
        searchInfo: { $set: action.info },
      })
    }
    case STORE_USERS_ACTIVEINFO: {
      return update(state, {
        activeInfo: { $set: action.info },
      })
    }
    case NEW_USER: {
      return update(state, {
        currentUser: { $set: action.user },
      })
    }
    case GET_USER: {
      return update(state, {
        currentUser: { $set: action.response },
      })
    }
    case UPDATE_USER: {
      if (state.currentUser.email !== action.response.email) {
        return update(state, {
          currentUser: {
            $set: { ...action.response, temporaryEmail: action.response.email },
          },
        })
      }
      return update(state, {
        currentUser: { $set: action.response },
      })
    }
    case CLEAR_USER: {
      return update(state, {
        currentUser: { $set: null },
      })
    }
    case CLEAR_USER_SEARCH_INFO: {
      return update(state, {
        searchInfo: { search: { $set: '' } },
      })
    }
    case DELETE_USER: {
      const byHash = { ...state.byHash }
      // return all the items not matching the action.id
      const byId = state.byId.filter(item => item !== action.id)

      delete byHash[action.id] // delete the hash associated with the action.id

      return update(state, {
        byId: { $set: byId },
        byHash: { $set: byHash },
      })
    }
    case CLEAR_USERS: {
      return initialState
    }
    case LOAD_USER_ROLES: {
      return update(state, {
        validRoles: { $set: action.response.roles },
      })
    }
    default:
      return state
  }
}

export default users
